export default __webpack_public_path__ + "static/media/_view-icon.0e1db30e.svg";